<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="REDES Y CONTACTOS" />

      <b-row align-h="center" align-v="center" class="mt-5 mb-4">
        <b-col cols="7">
          <b-card class="bg-light px-3 py-4" no-body style="border-color: #163D7D;">
            <div class="d-flex justify-content-between align-items-center px-3">
              <div>
                <p class="mb-0 configurator-label fs-20" style="font-weight: 500;" >
                  ¿Requiere gestiones informáticas y validaciones de instalación?
                </p>
                <p class="text-muted mb-0 fs-14 ml-2" style="line-height: 8px;">
                  Si no requiere, se omitirán todas las preguntas de esta sección
                </p>
              </div>
              <div class="d-flex">
                <b-button
                  class="mr-2"
                  :variant="form.network_configuration_required === true ? 'primary' : 'outline-secondary'"
                  size="sm"
                  style="width: 55px;"
                  @click="form.network_configuration_required = true"
                >
                  <span>Sí</span>
                </b-button>
                <b-button
                  :variant="form.network_configuration_required === false ? 'primary' : 'outline-secondary'"
                  size="sm"
                  style="width: 55px;"
                  @click="form.network_configuration_required = false"
                >
                  No
                </b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-row v-if="form.network_configuration_required" align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-4">
              <b-col>
                <b-card>
                  <div class="d-flex justify-content-center">
                    <Label label="Contacto Departamento TI" />
                  </div>
                  <div class="mb-2 mx-3">
                    <ValidationProvider rules="required" name="Nombre" style="width: 100%" v-slot="{ valid, errors }">
                      <Label label="Nombre " :blank="form.it_contact_name" show-reset @reset="form.it_contact_name = null" />
                      <b-input-group size="lg">
                        <b-input
                          v-model="form.it_contact_name"
                          type="text"
                          :state="errors[0] ? false : (valid ? true : false)"
                          trim
                        />
                      </b-input-group>
                    </ValidationProvider>
                  </div>
                  <div class="mb-2 mx-3">
                    <ValidationProvider :rules="{ required: true, email: true }" name="Correo" style="width: 100%" v-slot="{ valid, errors }">
                      <Label label="Correo" :blank="form.it_contact_email" show-reset @reset="form.it_contact_email = null" />
                      <b-input-group size="lg">
                        <b-input
                          v-model="form.it_contact_email"
                          type="text"
                          :state="errors[0] ? false : (valid ? true : false)"
                          trim
                        />
                      </b-input-group>
                    </ValidationProvider>
                  </div>
                  <div class="mx-3">
                    <ValidationProvider :rules="{ required: true, numeric: true }" name="Teléfono" style="width: 100%" v-slot="{ valid, errors }">
                      <Label label="Celular" :blank="form.it_contact_phone" show-reset @reset="form.it_contact_phone = null" />
                      <b-input-group size="lg">
                        <b-input
                          v-model="form.it_contact_phone"
                          type="text"
                          :state="errors[0] ? false : (valid ? true : false)"
                          trim
                        />
                      </b-input-group>
                    </ValidationProvider>
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <b-row
              v-for="item in tableQuestions"
              :key="item.model"
              class="align-items-center py-2"
            >
              <b-col cols="12" lg="9" class="px-0">
                <Label
                  :label="item.label"
                  :show-reset="form[item.model] == true || form[item.model] == false"
                  :blank="form[item.model] === null ? null : 'true'"
                  @reset="form[item.model] = null"
                />
              </b-col>

              <b-col cols="12" lg="3" class="text-lg-right mt-2 mt-lg-0 px-0">
                <b-form-group>
                  <b-radio-group size="lg" v-model="form[item.model]" class="ml-4">
                    <b-radio :value="true">Si</b-radio>
                    <b-radio :value="false">No</b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
            </b-row>

            <StepNotes
              :value="form.network_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'
import StepNotes from '../StepNotes'


export default {
  name: 'General',
  components: {
    ConfiguratorStepTitle,
    ValidationObserver,
    ValidationProvider,
    Label,
    StepNotes,
  },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      processing: false,
      form: {
        it_contact_name: '',
        it_contact_email: '',
        it_contact_phone: '',
        has_reliable_network: null,
        has_dedicated_network: null,
        has_dedicated_computer: null,
        has_wall_or_rack_mounting: null,
        has_corrosive_environment: null,
        has_extreme_conditions: null,
        network_configuration_required: true,
        network_notes: ''
      },
      tableQuestions: [
        {
          label: "Cliente indica que la Infraestructura de red es estable y confiable",
          model: "has_reliable_network"
        },
        {
          label: "Red exclusiva para nuestros sistemas",
          model: "has_dedicated_network"
        },
        {
          label: "Computadora dedicada para nuestros sistemas",
          model: "has_dedicated_computer"
        },
        {
          label: "Paneles para soluciones en paredes o soluciones para rack",
          model: "has_wall_or_rack_mounting"
        },
        {
          label: "Área donde se instala, tiene componentes abrasivos o corrosivos para los componentes periféricos",
          model: "has_corrosive_environment"
        },
        {
          label: "Condiciones climáticas para equipos periféricos al exterior o incluso temperaturas críticas",
          model: "has_extreme_conditions"
        }
      ]
    }
  },
  mounted () {
    if (this.controlAcceso) {
      this.form.network_configuration_required = this.controlAcceso.network_configuration_required
      this.form.it_contact_name = this.controlAcceso.it_contact_name
      this.form.it_contact_email = this.controlAcceso.it_contact_email
      this.form.it_contact_phone = this.controlAcceso.it_contact_phone
      this.form.has_reliable_network = this.controlAcceso.has_reliable_network
      this.form.has_dedicated_network = this.controlAcceso.has_dedicated_network
      this.form.has_dedicated_computer = this.controlAcceso.has_dedicated_computer
      this.form.has_wall_or_rack_mounting = this.controlAcceso.has_wall_or_rack_mounting
      this.form.has_corrosive_environment = this.controlAcceso.has_corrosive_environment
      this.form.has_extreme_conditions = this.controlAcceso.has_extreme_conditions
      this.form.network_notes = this.controlAcceso.network_notes
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    ...mapGetters(['configuratorStepNumber']),
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable({
        controlacceso: this.form
      })

      return result
    },
    formHasChanged () {
      // TODO: implement this
      return true
      // return Object.entries(this.form).some(([key, value]) => value !== this.controlAcceso[key])
    },
    updateStepNotes (notes) {
      this.form.network_notes = notes
    }
  }
}
</script>